// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contentful-image--btWzK{max-width:100%;height:auto;border-radius:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentful-image": "contentful-image--btWzK"
};
export default ___CSS_LOADER_EXPORT___;
